import { render } from "./ClientSidepanel.vue?vue&type=template&id=3189d37a&scoped=true"
import script from "./ClientSidepanel.vue?vue&type=script&lang=js"
export * from "./ClientSidepanel.vue?vue&type=script&lang=js"

import "./ClientSidepanel.vue?vue&type=style&index=0&id=3189d37a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3189d37a"]])

export default __exports__